import * as Yup from "yup";
export const validationRegistration = (text: any) => Yup.object({
  email: Yup.string().email(text["Invalid email address"]).required(text["Email is required"]),
  name: Yup.string().required(text["Name is required"]),
  city: Yup.string().required(text["City is required"])
});